import React from 'react';
import { Link } from 'react-router-dom';

/* Waar je bent, en hoe je terugkomt.

   Een pagina die je vanuit een andere pagina opent hoort te vertellen waar hij
   vandaan komt. Zonder dat sta je na één klik in een scherm zonder weg terug en
   moet je opnieuw gaan zoeken — met de browserknop, of via het menu.

   Gebruik:

     <Kruimels stappen={[
       { label: fmtId('I-00007'), naar: '/beregening/inrichtingen/I-00007' },
       { label: 'Wijzigingsbesluit WB-2026-1' },
     ]} />

   De laatste stap is waar je nú staat en krijgt geen link: klikken op iets dat
   je naar dezelfde pagina brengt is geen navigatie maar ruis. Een stap zonder
   `naar` is sowieso leestekst, zodat je ook een tussenstap kunt tonen die geen
   eigen pagina heeft. */
export default function Kruimels({ stappen = [] }) {
  const zichtbaar = stappen.filter(Boolean);
  if (zichtbaar.length === 0) return null;
  return (
    <nav className="kruimels" aria-label="Kruimelpad">
      {zichtbaar.map((stap, i) => {
        const laatste = i === zichtbaar.length - 1;
        return (
          <React.Fragment key={`${stap.label}-${i}`}>
            {i > 0 && <span className="kruimel-scheider" aria-hidden="true">›</span>}
            {stap.naar && !laatste
              ? <Link to={stap.naar}>{stap.label}</Link>
              : <span className={laatste ? 'kruimel-hier' : undefined}>{stap.label}</span>}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
